import { UnitDecorator } from "./UnitModel";
import { BatchDecorator } from "./BatchModel";

export const BillModel = {
  code: "",
  id: "",
  image: "",
  name: "",
  quantity: 1,
  reference_number: "",
  minCurrentMoneyVisible: false,
  unit: [],
  batch: [],
  available_stock: 0,
  price: 0,
  bargain_discount: 0,
  isBargained: false,
  comment: "",
  productInformation: {},

  //  product_id: 1,
  //  batch_id: 1,
  //  unit_id: 13,
  //  quantity: 2,
  //  bargain_discount: 500,
  //  amount: 500,
  //  comment: "dddddd",
};

export class BillDecorator {
  constructor(product) {
    this.product = product;
  }

  toBill() {
    return {
      code: this.product.code ? this.product.code : "",
      id: this.product.id ? this.product.id : "",
      image: this.product.image ? this.product.image : "",
      name: this.product.name ? this.product.name : "",
      minCurrentMoneyVisible: this.product.minCurrentMoneyVisible
        ? this.product.minCurrentMoneyVisible
        : false,
      quantity: this.product.quantity ? this.product.quantity : "",
      reference_number: this.product.reference_number
        ? this.product.reference_number
        : "",
      unit: this.product.unit,
      batch: this.product.batch,
      available_stock: this.product.available_stock,

      // unit: this.product.unit
      //   ? new UnitDecorator(this.product.unit).toRequest()
      //   : "",
      // batch: this.product.batch
      //   ? new BatchDecorator(this.product.batch).toRequest()
      //   : "",
      price: this.product.price ? this.product.price : 0,
      productInformation: this.product.productInformation,
      isMinPriceEnabled: false,
    };
  }
  toRequest() {
    return {
      code: this.product.code ? this.product.code : "",
      id: this.product.id ? this.product.id : "",
      image: this.product.image ? this.product.image : "",
      name: this.product.name ? this.product.name : "",
      quantity: this.product.quantity ? this.product.quantity : "",
      reference_number: this.product.reference_number
        ? this.product.reference_number
        : "",
      unit: this.product.unit,
      batch: this.product.batch,
      // available_stock: this.product.available_stock,

      // unit: this.product.unit
      //   ? new UnitDecorator(this.product.unit).toRequest()
      //   : "",
      // batch: this.product.batch
      //   ? new BatchDecorator(this.product.batch).toRequest()
      //   : "",
      price: this.product.price ? this.product.price : 0,
    };
  }
}
